import request from '@/axios'

// 单价列表
export function getDj(data={}) {
    return request({
        url: '/pay/price/list',
        method: 'get',
        params: data
    })
}
// 某个单价
export function getDj1(id) {
    return request({
        url: `/pay/price/info/${id}`,
        method: 'get',
        // params: data
    })
}
// 新增单价
export function addDj(data={}) {
    return request({
        url: `/pay/price/save`,
        method: 'post',
        data: data
    })
}
// 修改单价
export function updateDj(data={}) {
    return request({
        url: `/pay/price/update`,
        method: 'post',
        data: data
    })
}
// 删除单价
export function delDj(data={}) {
    return request({
        url: `/pay/price/delete`,
        method: 'post',
        data: data
    })
}